const Cookies = require('js-cookie');

const COOKIES_ACCEPTED_KEY = 'gdpr_consent';
const COOKIES_DENIED_KEY = 'gdpr_consent_denied';

const bannerTempl = require('./partials/cookie_banner.mustache');
const ajax = require('sma.common/ajax');

const STRINGS = {
	accept: gettext('AGREE'),
	no: gettext('NO'),
	title: interpolate(
		'Our <a href="%(cookie)s" target="_blank">Cookie Policy</a> and <a href="%(privacy)s" target="_blank">Privacy Policy</a> outline how we use cookies to help personalize content, tailor and measure our marketing, and improve your user experience. I agree to use cookies for these purposes.', 
		{
			cookie: 'https://apply.surveymonkey.com/cookie-policy/',
			privacy: 'https://www.surveymonkey.com/mp/legal/privacy-basics-enterprise/'
		},
		true
	)
};

class CookieBanner extends Backbone.View {
	events() {
		return {
			'click .sma-js-cookie-accept': 'clickedAgree',
			'click .sma-js-cookie-reject': 'clickedNo'
		};
	}

	static canAcceptCookies() {
		let cookies_accepted = Cookies.get(COOKIES_ACCEPTED_KEY);

		return cookies_accepted ? true : false;
	}

	eitherCookieExists() {
		let cookies_accepted = Cookies.get(COOKIES_ACCEPTED_KEY);
		let cookies_rejected = Cookies.get(COOKIES_DENIED_KEY);

		return (cookies_accepted || cookies_rejected) ? true : false;
	}

	banner() {
		return $('.sma-js-cookie-banner');
	}

	deleteCookies() {
		// Google Analytics cookies
		let gaCookies = [
			'_ga',
			'_gid',
			'_gat'
		];

		gaCookies.forEach((cookie) => {
			Cookies.remove(cookie, {
				domain: location.hostname
			});
		});

		gaCookies.forEach((cookie) => {
			Cookies.remove(cookie, {
				domain: '.' + location.hostname
			});
		});
	}

	showBanner() {
		let banner = $(bannerTempl({
			strings: STRINGS
		}));

		$('.sma-js-topbar').prepend(banner);
	}

	initialize() {
		this.setElement('.sma-js-topbar');

		// Check if a cookie exists (accepted or rejected)
		// If neither cookie exists, delete all existing cookies and show the banner
		if(this.eitherCookieExists()) {
			return;
		} else {
			ajax.get({
				url: reverse('in-gdpr-country'),
				alertOnSuccess: false,
				alertOnError: false,
				callback: (result) => {
					if(result.is_in_region) {
						this.deleteCookies();
						this.showBanner();
					} else {
						this.setAcceptedCookie();
					}
				}
			});
		}
	}

	clickedAgree(e) {
		e.preventDefault();

		this.banner().remove();

		// GDPR states the accepted cookie can remain for 1 year
		this.setAcceptedCookie();
	}

	setAcceptedCookie() {
		Cookies.set(COOKIES_ACCEPTED_KEY, 1, {
			expires: 365
		});
	}

	clickedNo(e) {
		e.preventDefault();

		this.deleteCookies();
		this.banner().remove();

		// GDPR states the rejected cookie can remain for 1 week
		Cookies.set(COOKIES_DENIED_KEY, 1, {
			expires: 7
		});
	}
}

module.exports = CookieBanner;



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.common/components/cookie_banner.js